import { render, staticRenderFns } from "./MiAvatar.vue?vue&type=template&id=6b2ba74b&scoped=true"
import script from "./MiAvatar.vue?vue&type=script&lang=js"
export * from "./MiAvatar.vue?vue&type=script&lang=js"
import style0 from "./MiAvatar.vue?vue&type=style&index=0&id=6b2ba74b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ba74b",
  null
  
)

export default component.exports